import React from 'react';

const TagUserFormModal = React.lazy(() => import('../components/FormModal'));
const tagUserModalRegistry = {
    crm_tagUserId: TagUserFormModal
};
export default tagUserModalRegistry;
